import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class ImprovementsModifyOrderRulesFeature implements IFlagFeature {
  name: string = Features.IMPROVEMENTS_MODIFY_ORDER_RULES;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
